export enum SidebarType {
    PROFILE = 1,
    DASHBOARD = 2,
}